import SidebarBookingsDetailsController from 'uplisting-frontend/pods/-sidebar/bookings/details/controller';

export default class ProtectionOverviewBookingsDetailsController extends SidebarBookingsDetailsController {}
